module.exports = __webpack_public_path__ + "img/flex5_5-front.16136da3.jpg";